import { type ReactElement } from 'react';

export type WorkspaceViewMode = 'ide' | 'terminal' | 'browser';

interface ViewModeToggleProps {
  value: WorkspaceViewMode;
  onChange: (next: WorkspaceViewMode) => void;
  disabled: boolean;
  showBrowser: boolean;
}

const OPTIONS: readonly { value: WorkspaceViewMode; label: string }[] = [
  { value: 'ide', label: 'IDE' },
  { value: 'terminal', label: 'Terminal' },
  { value: 'browser', label: 'Browser' },
];

export function ViewModeToggle({
  value,
  onChange,
  disabled,
  showBrowser,
}: ViewModeToggleProps): ReactElement {
  return (
    <fieldset
      className="workspace-view-toggle"
      aria-label="Workspace view mode"
      disabled={disabled}
    >
      {OPTIONS.filter((option) => showBrowser || option.value !== 'browser').map((option) => {
        const isActive = value === option.value;
        const optionClassName = isActive
          ? 'workspace-view-toggle__option workspace-view-toggle__option--active'
          : 'workspace-view-toggle__option';
        return (
          <label
            key={option.value}
            className={optionClassName}
            data-disabled={disabled ? 'true' : 'false'}
          >
            <input
              type="radio"
              name="workspace-view"
              value={option.value}
              checked={isActive}
              onChange={() => { onChange(option.value); }}
              disabled={disabled}
              className="workspace-view-toggle__input"
            />
            <span>{option.label}</span>
          </label>
        );
      })}
    </fieldset>
  );
}
